import type { BookChapter } from '@/components/books/book';
import type { BookCardBook } from '@/components/books/book-card';
import type { MaDeletedSectionRow, MaSharedBookRef, MaUnplacedSectionRow } from '@/lib/ma-books-api';
import type { LucideIcon } from 'lucide-react';
import type { ComponentType } from 'react';

export type ActivitySidebarDeepLinkProps = {
    highlightSectionId?: string;
    focusTargetBooksForSectionId?: string;
    pickedSectionId?: string | null;
    onPickedSectionIdChange?: (sectionId: string) => void;
};

export type ActivitySidebarPanelProps = {
    book: BookCardBook;
    chapters: BookChapter[];
    unplacedSections: MaUnplacedSectionRow[];
    deletedSections: MaDeletedSectionRow[];
    sharedDocuments: Record<string, MaSharedBookRef[]>;
} & ActivitySidebarDeepLinkProps;

export type ActivitySidebarBadgeContext = {
    unplacedCount: number;
    deletedCount: number;
};

export type ActivitySidebarActionDef = {
    id: string;
    label: string;
    icon: LucideIcon;
    Panel: ComponentType<ActivitySidebarPanelProps>;
    getBadgeCount?: (ctx: ActivitySidebarBadgeContext) => number | undefined;
};

export type ActivitySidebarLinkDef = {
    id: string;
    label: string;
    icon: LucideIcon;
    getTo: (ctx: { bookId: string }) => string;
};

export type ActivitySidebarHandle = {
    activitySidebar: {
        actions: ActivitySidebarActionDef[];
        links?: ActivitySidebarLinkDef[];
    };
};

export function getActivitySidebarHandle(handle: unknown): ActivitySidebarHandle['activitySidebar'] | null {
    const h = handle as ActivitySidebarHandle | undefined;
    return h?.activitySidebar ?? null;
}
